import React, {useEffect} from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import {ChatMessage} from '../index'

export default function MessagesFromPastConversations({conversationIds, onLoad}) {
  const {messages} = useQuery({
    query: gql`
      query getMessages($conversationIds: [ID]) {
        messages: getMessages(conversationIds: $conversationIds) {
          _id
          text
          image {
            _id
            url
          }
          date
          isSystemMessage
          senderName
          sentByAdminId
        }
      }
    `,
    variables: {conversationIds: conversationIds}
  })

  useEffect(() => {
    onLoad()
  }, [messages])

  return messages.map(message => <ChatMessage key={message._id} message={message} />)
}
